<template>
  <a-modal v-model="visible" :title="`${form.id ? $t('编辑字典信息') : $t('新增字典信息')}`" :width="1000" destroyOnClose>
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('所属应用')" prop="appId">
            <a-select v-model="form.appId" :options="appOptions" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('字典名称')" prop="name">
            <a-input v-model="form.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('字典编码')" prop="code">
            <a-input v-model="form.code" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('备注')" prop="remark">
            <a-textarea v-model="form.remark" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveDict } from '@/api/system/dict'
import { getAppListForCurrentUser } from '@/api/app/app'

export default {
  data() {
    return {
      appOptions: [],
      visible: false,
      form: {},
      loading: false,
    }
  },
  computed: {
    rules() {
      const result = {
        name: [{ required: true, message: this.$t('请输入') }],
        code: [{ required: true, message: this.$t('请输入') }],
      }
      return result
    }
  },
  created() {
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.loadOptions()
      this.visible = true
    },
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          ...this.form,
        }
        saveDict(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>